module.exports = __webpack_public_path__ + "img/valid_phones_icon.6ead4270.png";